import { Text } from 'theme-ui'

import type { WithChildren } from 'src/types/utils'
import type { BoxProps, SxProp, TextProps } from 'theme-ui'

export type GelType = keyof typeof typeDefintions

type ComponentProps = SxProp & WithChildren

export interface TypeProps extends ComponentProps {
  dangerouslySetInnerHTML?: BoxProps['dangerouslySetInnerHTML']
  variant: GelType
  as?: React.ElementType
  id?: BoxProps['id']
  className?: BoxProps['className']
  tabIndex?: BoxProps['tabIndex']
}

type GelTypeProps = Omit<TypeProps, 'variant'>

const typeDefintions = {
  HeadlineSerif: (props: GelTypeProps) => (
    <Text as="h1" variant="headlineSerif" {...(props as TextProps)} />
  ),
  HeadlineSans: (props: GelTypeProps) => (
    <Text as="h1" variant="headlineSans" {...(props as TextProps)} />
  ),
  DataLarge: (props: GelTypeProps) => (
    <Text as="h2" variant="dataLarge" {...(props as TextProps)} />
  ),
  SectionTitleSerif: (props: GelTypeProps) => (
    <Text as="h2" variant="sectionTitleSerif" {...(props as TextProps)} />
  ),
  GridCardSectionTitleSerif: (props: GelTypeProps) => (
    <Text as="h2" variant="girdCardSectionTitleSerif" {...(props as TextProps)} />
  ),
  SectionTitleSans: (props: GelTypeProps) => (
    <Text as="h2" variant="sectionTitleSans" {...(props as TextProps)} />
  ),
  SectionSubTitleSerif: (props: GelTypeProps) => (
    <Text as="h3" variant="sectionSubTitleSerif" {...(props as TextProps)} />
  ),
  SectionSubTitleSans: (props: GelTypeProps) => (
    <Text as="h3" variant="sectionSubTitleSans" {...(props as TextProps)} />
  ),
  Labels: (props: GelTypeProps) => <Text as="h4" variant="labels" {...(props as TextProps)} />,
  LabelsEmphasised: (props: GelTypeProps) => (
    <Text as="h4" variant="labelsEmphasised" {...(props as TextProps)} />
  ),
  LabelsSerif: (props: GelTypeProps) => (
    <Text as="h4" variant="labelsSerif" {...(props as TextProps)} />
  ),
  Body: (props: GelTypeProps) => <Text as="p" variant="body" {...(props as TextProps)} />,
  BodyEmphasised: (props: GelTypeProps) => (
    <Text as="p" variant="bodyEmphasised" {...(props as TextProps)} />
  ),
  MetaData: (props: GelTypeProps) => <Text as="p" variant="metaData" {...(props as TextProps)} />,
  MetaDataEmphasised: (props: GelTypeProps) => (
    <Text as="p" variant="metaDataEmphasised" {...(props as TextProps)} />
  )
}

const Type = ({ variant, ...rest }: TypeProps) => {
  const TypeComponent = typeDefintions[variant]
  return <TypeComponent {...rest} />
}

export default Type
